.page-frame {
  &.center-padding {
    padding-inline: var(--center-layout-padding);
  }
  &.with-header {
    --top-margin: clamp(var(--rds-spacing--16), 2.25vw, var(--rds-spacing--24));
    margin-top: var(--top-margin);
    position: relative;
  }
}

.title {
  --title-margin: var(--top-margin);
  margin-top: var(--title-margin);
  margin-bottom: var(--rds-spacing--24);
}
.tall-title {
  --title-margin: var(--rds-spacing--80);
}
.crumb > * > ol {
  flex-wrap: wrap;
}
